// Lý do cơ quan thuế từ chối bảng kê, mở từ icon lỗi ở cột Trạng thái.
import PropTypes from "prop-types";
import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const StatementRejectModal = props => {
  const { isOpen, toggle, statement } = props;

  return (
    <Modal isOpen={isOpen} role="dialog" autoFocus centered toggle={toggle}>
      <div className="modal-content">
        <ModalHeader toggle={toggle}>
          Lý do cơ quan thuế từ chối
          {statement?.code && (
            <span className="text-primary ms-2">{statement.code}</span>
          )}
        </ModalHeader>
        <ModalBody>
          <div
            className="alert alert-danger mb-0"
            style={{ whiteSpace: "pre-wrap" }}
          >
            {statement?.reject_reason || "Không có nội dung"}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="secondary" outline onClick={toggle}>
            Đóng
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  );
};

StatementRejectModal.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func.isRequired,
  statement: PropTypes.object,
};

StatementRejectModal.defaultProps = {
  isOpen: false,
  statement: null,
};

export default StatementRejectModal;
